import React from 'react';
import { Box } from '@mui/material';
import type { VitalRating } from '../services/usageFormat';

/**
 * RITA-1515 (Phase 3a), seit RITA-1523 auch im Versionsvergleich — Bewertung einer
 * Ladeleistungs-Kennzahl als Punkt vor dem Wert.
 *
 * Eigener Baustein, weil ihn zwei Tabellen zeigen (Ladeleistung und Versionsvergleich) und eine
 * zweite Umsetzung derselben drei Farben still auseinanderlaufen würde. Der Punkt trägt seinen
 * Namen als `aria-label`, `title` UND `data-bewertung`: die Farbe allein ist keine Aussage — für
 * Screenreader nicht, für Farbenblinde nicht und für Tests nicht.
 *
 * Ohne Bewertung (kein Wert, Textmarke des Servers) bleibt der Punkt weg statt grau zu raten.
 */
export const BEWERTUNG_FARBE: Record<VitalRating, string> = {
  gut: 'success.main',
  verbesserungswürdig: 'warning.main',
  schlecht: 'error.main',
};

export interface BewertungspunktProps {
  rating: VitalRating | null;
}

export default function Bewertungspunkt({ rating }: BewertungspunktProps) {
  if (rating === null) return null;
  return (
    <Box
      component="span"
      role="img"
      aria-label={rating}
      title={rating}
      data-bewertung={rating}
      sx={{
        display: 'inline-block',
        width: 8,
        height: 8,
        borderRadius: '50%',
        mr: 0.75,
        bgcolor: BEWERTUNG_FARBE[rating],
        verticalAlign: 'baseline',
      }}
    />
  );
}
